import { isInIframe } from '@shared/utils/isInIframe';
import { EventFeature, useProFeature } from '@shared/hooks/useProFeature';

const CARBON_IFRAME_LINK_PROPS = { target: '_blank', rel: 'noopener' } as const;

/**
 * True when the guest site is rendered inside the Carbon website-editor iframe.
 * In that context same-origin navigations would replace the iframe content and
 * hijack the parent Carbon app, so callers should redirect via a new tab
 * instead (e.g. `window.open(url, '_blank')` rather than `history.push`).
 */
export const useIsCarbonIframe = (): boolean => {
  const isCarbonScopedWebsiteEditor = useProFeature(EventFeature.useCarbonScopedWebsiteEditor);
  return isCarbonScopedWebsiteEditor && isInIframe();
};

/**
 * Spread the returned props on links/buttons that perform same-origin navigation
 * so they open in a new tab when rendered inside the Carbon website-editor iframe.
 */
export const useCarbonIframeLinkProps = (): { target: '_blank'; rel: 'noopener' } | Record<string, never> => {
  const isCarbonIframe = useIsCarbonIframe();
  return isCarbonIframe ? CARBON_IFRAME_LINK_PROPS : {};
};
